import { useQuery } from "react-query";
import { GET_SLEEP_PROFILE, STALE_TIME_5_MINUTES } from "@constants/reactQueryKeys";
import { getSleepProfile } from "api/customers";

const useGetSleepProfile = (clientId: number | null) => {
  const { data, isLoading, refetch, ...rest } = useQuery(
    [GET_SLEEP_PROFILE, clientId],
    () => getSleepProfile(clientId),
    {
      staleTime: STALE_TIME_5_MINUTES,
      enabled: Boolean(clientId),
      refetchOnWindowFocus: false,
    }
  );

  return {
    sleepProfile: data?.data || null,
    sleepProfileLoading: isLoading,
    refetchSleepProfile: refetch,
    ...rest,
  };
};

export default useGetSleepProfile;
